import { Link, useLocation, useParams } from "react-router-dom";

function NotFoundContent({ tenant }: { tenant?: string | undefined }) {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-16 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <main className="mx-auto flex max-w-xl flex-col gap-4 rounded border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900">
        <h1 className="text-2xl font-bold">404</h1>
        <p className="text-sm text-slate-600 dark:text-slate-300">Die aufgerufene Seite wurde nicht gefunden.</p>
        <p className="text-sm text-slate-600 dark:text-slate-300">
          {tenant !== undefined ? `Pfad im Tenant ${tenant} ist ungültig.` : "Unbekannte oder ungültige Seite."}
        </p>
        <div className="flex flex-wrap gap-3">
          <Link
            to={tenant ? `/${tenant}/` : "/"}
            className="rounded bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-400"
          >
            Zur Statusseite
          </Link>
          <Link
            to={tenant ? `/${tenant}/admin` : "/"}
            className="rounded border border-blue-600 px-4 py-2 text-sm text-blue-700 hover:bg-blue-50 dark:border-blue-400 dark:text-blue-300 dark:hover:bg-slate-800"
          >
            Zur Admin-Übersicht
          </Link>
        </div>
      </main>
    </div>
  );
}

export default function NotFoundPage() {
  const location = useLocation();
  const { tenant } = useParams<{ tenant: string }>();

  const path = location.pathname;
  const tenantHint = tenant !== undefined && path.startsWith(`/${tenant}/`) ? tenant : undefined;

  return <NotFoundContent tenant={tenantHint} />;
}
